import { ButtonPill } from "@momentum-ui/react-collaboration";
import React, { ReactElement } from "react";
import { useTranslation } from 'react-i18next';
import './WebexSignInPage.scss';


type IWebexSignInProps = {
  signInImage: ReactElement;
  signInTitle: string;
  signInMessageStart: string;
  signInMessageEnd: string;
  signInButtonText: string;
  footNote: ReactElement;
  showSignInOrRetry: boolean;
  signInDifferentAccountText?: string;
  signInAction: (useDifferentAccount?: boolean) => void;
  signingIn: boolean;
  headerNoteStart?: string;
  headerNoteEnd?: string;
  email?: string;
  clientType: string;
};

export const WebexSignInPage = ({
  signInImage,
  signInTitle,
  signInMessageStart,
  signInMessageEnd,
  signInButtonText,
  footNote,
  showSignInOrRetry,
  signInDifferentAccountText,
  signInAction,
  headerNoteStart,
  headerNoteEnd,
  email,
  signingIn,
  clientType
}: IWebexSignInProps) => {
  const { t } = useTranslation('WebexSpeedDials');
  return (
    <div>
      <div className={`sign-in-page ${clientType !== 'desktop' && clientType !== 'web' ? 'sign-in-page__mobile' : ''}`}>
        {!signingIn && (
          <div className={`webex-message-container ${clientType !== 'desktop' && clientType !== 'web' ? 'webex-message-container__mobile' : ''} ${showSignInOrRetry ? `webex-message-container__error` : ''}`}>
            <div className="icon">
              {signInImage}
            </div>
            <div className="signInText">
              <p className="title">{signInTitle}</p>
              {signInMessageStart && (
                <p className="message">{signInMessageStart}<b>{email}</b>{signInMessageEnd}</p>)
              }
              {headerNoteStart && (
                <div className="header">{headerNoteStart}<b>{email}</b>{headerNoteEnd}</div>
              )}
            </div>
            <div className="close1">
              <ButtonPill size={32} onPress={() => signInAction(false)}>
                {signInButtonText}
              </ButtonPill>
              {signInDifferentAccountText && (
                <div className="close2">
                  <ButtonPill size={32} onPress={() => signInAction(true)}>
                    {signInDifferentAccountText}
                  </ButtonPill>
                </div>
              )}
            </div>
            {(clientType !== 'desktop' && clientType !== 'web') && footNote}
          </div>
        )}
        {signingIn && (
          <div>{t('signIn.signingIn')}</div>
        )}
        {!signingIn && !(clientType !== 'desktop' && clientType !== 'web') && footNote}
      </div>
    </div>
  );
};